import { render } from "./PessoaJuridica.vue?vue&type=template&id=ee9da53e&scoped=true"
import script from "./PessoaJuridica.vue?vue&type=script&lang=js"
export * from "./PessoaJuridica.vue?vue&type=script&lang=js"

import "./PessoaJuridica.vue?vue&type=style&index=0&id=ee9da53e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9da53e"]])

export default __exports__